export default __webpack_public_path__ + "static/media/COM.be20a1d9.svg";